import { render } from "./Photos.vue?vue&type=template&id=3346fc35&scoped=true"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"

import "./Photos.vue?vue&type=style&index=0&id=3346fc35&scoped=true&lang=css"

import exportComponent from "/home/web/vina_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3346fc35"]])

export default __exports__